import { render } from "./SocialPage.vue?vue&type=template&id=7417561a"
import script from "./SocialPage.vue?vue&type=script&lang=js"
export * from "./SocialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/SocialPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7417561a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7417561a', __exports__)) {
    api.reload('7417561a', __exports__)
  }
  
  module.hot.accept("./SocialPage.vue?vue&type=template&id=7417561a", () => {
    api.rerender('7417561a', render)
  })

}


export default __exports__